import React from 'react'

import RecordHeading from '../../../ui/record-heading'
import RecordDisplay from '../../../ui/record-display'

const levelOneDisplayRecordFields = [
  {
    key: 'StartDate',
    label: 'Start Date',
  },
  {
    key: 'EndDate',
    label: 'End Date',
  },
  {
    key: 'ISCaseId',
    label: 'Case ID',
  },
]

const levelTwoDisplayRecordsFields = [
  {
    key: 'CareProvision',
    label: 'Care Provision',
  },
  {
    key: 'TotalISNonFaceToFaceHrsAllowed',
    label: 'Non Face To Face Hrs Allowed'
  },
  {
    key: 'ISNonFaceToFaceHrsBalance',
    label: 'Non Face to Face Hrs Balance'
  },
  {
    key: 'CCBApprovalId',
    label: 'CCB Approval ID',
  },
]

const formatGovRecordName = ({ CareEnvironmentName }) => ({
  first_name: '',
  last_name: CareEnvironmentName,
})

const IssCase = ({ record = {} }) => (
  <div className="issCase">
    <RecordHeading record={formatGovRecordName(record.gov_record)} />
    <RecordDisplay
      {...{
        record: record.gov_record,
        level1: levelOneDisplayRecordFields,
        recordBase: 'details',
        level2: levelTwoDisplayRecordsFields,
        showRaw: true,
      }}
    />
  </div>
)

export default IssCase



// WEBPACK FOOTER //
// ./src/iss-cases/details/views/index.jsx